import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1024.000000 1024.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)">
<path d="M0 5120 l0 -5120 5120 0 5120 0 0 5120 0 5120 -5120 0 -5120 0 0
-5120z m5425 3050 c200 -19 413 -67 610 -139 134 -49 336 -147 428 -208 104
-70 82 -68 -28 3 -51 32 -228 124 -239 124 -3 0 -35 14 -69 30 -35 17 -69 30
-75 30 -5 0 -43 11 -84 25 -123 42 -305 84 -437 101 -146 18 -429 20 -556 4
-244 -30 -432 -69 -512 -106 -17 -7 -37 -14 -45 -14 -29 -1 -215 -81 -301
-131 -140 -79 -268 -159 -290 -180 -12 -10 -24 -19 -28 -19 -4 0 -26 -16 -49
-35 -39 -33 -50 -40 -50 -32 0 3 55 48 145 119 112 89 362 223 538 287 129 48
321 100 409 111 44 5 84 13 90 17 30 18 392 27 543 13z m-340 -609 c167 -67
232 -75 289 -36 l39 26 -6 -83 c-4 -46 -7 -155 -8 -243 0 -122 -3 -153 -11
-130 -5 17 -23 65 -39 108 -95 256 -330 393 -595 348 -93 -16 -142 -42 -202
-105 -71 -75 -101 -175 -83 -284 13 -81 43 -140 100 -198 37 -37 149 -114 166
-114 3 0 29 -11 59 -25 30 -14 58 -25 63 -25 23 0 262 -98 362 -148 128 -64
200 -123 263 -215 58 -85 79 -153 81 -260 l2 -90 132 -3 c204 -5 439 -52 538
-108 103 -58 123 -71 178 -113 68 -52 127 -109 127 -122 0 -5 4 -11 9 -13 10
-4 80 -116 117 -189 26 -52 49 -119 58 -172 3 -16 9 -43 15 -60 5 -18 12 -52
15 -77 2 -25 8 -72 11 -105 13 -108 -14 -342 -51 -450 -8 -23 -14 -46 -14 -53
0 -24 -90 -199 -131 -254 -47 -64 -73 -78 -40 -22 12 20 19 39 16 43 -9 9 -35
-29 -36 -53 -1 -12 -2 -27 -3 -34 -3 -33 -112 -123 -208 -172 -55 -28 -103
-48 -106 -45 -3 2 -10 1 -16 -4 -22 -18 -139 -52 -214 -62 -104 -14 -1110 -20
-1059 -7 43 12 98 72 115 128 8 23 12 250 14 689 l3 655 -135 1 c-157 2 -189
9 -402 96 -205 83 -258 81 -321 -11 -21 -31 -21 -35 -2 180 8 91 15 207 15
258 0 90 11 119 24 65 11 -42 55 -152 85 -208 65 -124 181 -230 302 -276 103
-39 285 -46 392 -15 l39 11 -1 167 c-1 106 -6 178 -13 195 -22 51 -59 91 -101
112 l-42 21 45 1 c25 1 108 2 184 3 151 1 162 5 131 52 -28 43 -91 94 -183
148 -94 55 -100 58 -267 118 -327 117 -514 264 -581 455 -24 71 -30 223 -10
305 49 211 183 345 426 428 76 26 99 29 225 25 106 -2 115 -4 240 -54z m-1425
15 c0 -2 -12 -12 -27 -21 l-28 -18 19 21 c17 20 36 29 36 18z m-387 -435 c-10
-17 -40 -66 -66 -110 -27 -45 -51 -81 -53 -81 -7 0 48 101 90 163 39 58 63 81
29 28z m-240 -456 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15 13 8 -4z
m-33 -82 c-11 -17 -11 -17 -6 0 3 10 6 24 7 30 0 9 2 9 5 0 3 -7 0 -20 -6 -30z
m-33 -95 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-17 -73 c-7
-25 -15 -43 -18 -41 -2 3 2 25 9 50 7 25 15 43 17 41 3 -2 -1 -25 -8 -50z
m-81 -521 c-6 -98 -13 -181 -16 -184 -6 -6 4 235 14 318 11 101 12 44 2 -134z
m-2 -291 c-2 -16 -4 -3 -4 27 0 30 2 43 4 28 2 -16 2 -40 0 -55z m10 -115 c-2
-13 -4 -3 -4 22 0 25 2 35 4 23 2 -13 2 -33 0 -45z m10 -100 c-2 -13 -4 -3 -4
22 0 25 2 35 4 23 2 -13 2 -33 0 -45z m20 -100 c-3 -8 -6 -5 -6 6 -1 11 2 17
5 13 3 -3 4 -12 1 -19z m387 6 c32 -12 15 -23 -26 -18 -53 7 -84 -12 -74 -44
5 -13 18 -24 34 -27 59 -12 77 -21 91 -47 14 -25 14 -29 -5 -55 -19 -25 -28
-28 -77 -28 -31 0 -62 6 -69 13 -19 19 -3 24 40 13 54 -15 95 0 90 32 -2 17
-15 26 -58 40 -80 26 -102 65 -60 107 20 20 80 27 114 14z m1123 -14 c44 -26
61 -82 40 -132 -21 -51 -55 -70 -137 -76 l-70 -5 0 117 0 116 68 0 c49 0 76
-5 99 -20z m-373 -24 c-1 -11 6 -16 27 -16 16 0 29 -4 29 -10 0 -5 -11 -10
-25 -10 -24 0 -25 -3 -25 -59 0 -56 1 -60 25 -63 34 -4 33 -22 -2 -26 -38 -5
-53 20 -53 89 0 37 -5 59 -12 62 -10 4 -10 7 0 15 7 5 12 13 11 18 -3 18 1 26
14 21 6 -2 11 -12 11 -21z m681 3 c0 -7 14 -17 30 -20 30 -6 28 -9 -20 -24
-11 -3 -13 -16 -8 -57 6 -55 16 -70 41 -60 10 3 13 0 10 -9 -7 -21 -37 -23
-59 -3 -15 13 -19 31 -19 76 0 45 -3 58 -15 58 -8 0 -15 4 -15 9 0 5 7 11 15
15 8 3 15 13 15 22 0 8 6 14 13 12 6 -3 12 -11 12 -19z m-1797 -64 c0 -16 -2
-15 -8 5 -4 14 -8 34 -8 45 0 16 2 15 8 -5 4 -14 8 -34 8 -45z m865 44 c33
-18 37 -28 37 -101 0 -61 -9 -84 -24 -59 -4 5 -18 5 -35 -2 -43 -16 -81 3 -81
41 0 39 17 52 67 52 36 0 43 3 43 20 0 23 -37 36 -74 26 -14 -3 -27 -2 -31 4
-3 5 7 12 22 16 15 3 33 7 38 9 6 2 11 4 13 4 2 1 13 -4 25 -10z m835 -17 c14
-19 17 -152 3 -152 -6 0 -12 4 -16 10 -4 6 -15 6 -32 -1 -57 -21 -103 15 -80
62 10 19 21 25 60 27 31 2 47 8 47 16 0 26 -29 39 -70 32 -44 -7 -55 8 -17 24
30 13 89 3 105 -18z m-1113 9 c6 0 28 2 50 5 59 8 80 -18 80 -100 0 -48 -3
-61 -15 -61 -11 0 -16 15 -18 62 -2 51 -7 65 -23 74 -16 8 -26 7 -45 -6 -21
-14 -24 -23 -24 -76 0 -83 -23 -76 -30 10 -6 76 -31 99 -72 67 -12 -8 -18 -30
-20 -71 -2 -35 -8 -60 -15 -63 -10 -3 -13 18 -13 81 l0 85 68 -3 c37 -2 72 -4
77 -4z m465 -2 c0 -5 -13 -15 -30 -20 -34 -12 -43 -33 -39 -89 2 -22 -1 -41
-6 -42 -6 -2 -11 32 -13 77 l-3 81 46 2 c25 1 45 -3 45 -9z m952 -6 c14 -13
18 -31 18 -85 0 -61 -9 -84 -24 -59 -4 5 -18 5 -35 -2 -43 -16 -81 3 -81 42 0
38 21 53 70 53 27 -1 40 4 40 12 0 26 -29 39 -70 32 -23 -3 -40 -2 -40 3 0 25
95 28 122 4z m-1899 -335 c74 -200 190 -402 335 -583 173 -217 453 -458 677
-585 50 -28 253 -130 260 -130 2 0 28 -11 57 -24 87 -40 265 -92 403 -119 169
-33 215 -38 425 -47 l175 -8 -220 3 c-366 5 -624 65 -942 220 -253 122 -420
242 -646 462 -298 290 -488 603 -611 1010 -29 95 -15 90 19 -7 18 -52 49 -139
68 -192z m63 -2243 c31 -13 34 -17 28 -42 -9 -38 -10 -38 -47 -25 -53 19 -131
15 -151 -7 -26 -29 -7 -56 51 -70 140 -36 173 -60 173 -125 0 -55 -26 -89 -85
-112 -53 -20 -145 -14 -202 12 -30 15 -34 20 -28 43 10 40 18 43 63 21 72 -35
172 -20 172 25 0 21 -34 44 -84 55 -108 24 -151 58 -151 119 0 47 27 88 68
106 42 19 149 19 193 0z m371 -52 c48 -104 143 -324 143 -329 0 -2 -20 -4 -44
-4 -43 0 -45 1 -63 45 l-18 45 -93 0 -93 0 -20 -45 c-19 -42 -22 -45 -59 -45
-22 0 -40 2 -40 4 0 8 61 148 104 239 25 53 46 101 46 105 0 4 7 18 16 30 11
16 25 22 53 22 37 0 38 -2 68 -67z m324 0 c30 -38 59 -74 66 -81 7 -7 29 -33
50 -59 l38 -46 5 124 5 124 38 3 37 3 0 -200 0 -201 -40 0 c-22 0 -40 3 -40 8
0 4 -10 18 -23 32 -12 14 -39 47 -59 73 -43 56 -106 127 -113 127 -3 0 -5 -54
-5 -120 l0 -120 -40 0 -40 0 0 200 0 200 33 0 c29 0 40 -9 88 -67z m437 -136
l2 -198 -42 3 -43 3 -3 185 c-1 101 0 190 3 198 3 9 18 12 42 10 l38 -3 3
-198z m488 194 c142 -21 212 -129 172 -263 -14 -48 -74 -103 -127 -118 -22 -6
-89 -9 -148 -8 l-108 3 -3 185 c-1 101 0 190 2 197 6 15 118 17 212 4z m471
-3 c6 -7 27 -51 48 -98 20 -47 57 -129 81 -182 24 -54 44 -100 44 -103 0 -3
-20 -5 -44 -5 -43 0 -45 1 -62 45 l-17 45 -96 0 -97 0 -15 -42 c-15 -40 -18
-43 -57 -46 -23 -2 -42 -1 -42 1 0 5 155 349 170 376 12 24 71 29 87 9z m503
-23 l0 -35 -65 0 -65 0 0 -165 0 -165 -40 0 -40 0 -2 163 -3 162 -67 3 c-67 3
-68 3 -68 31 0 15 3 31 7 34 3 4 82 7 175 7 l168 0 0 -35z m335 -155 c47 -102
85 -191 85 -197 0 -8 -15 -13 -40 -13 -39 0 -42 2 -60 45 l-19 45 -94 0 -94 0
-17 -45 c-17 -44 -19 -45 -61 -45 l-43 0 75 168 c41 92 81 182 89 200 12 31
16 33 54 30 l41 -3 84 -185z m551 175 c32 -13 35 -18 29 -42 -9 -38 -11 -39
-48 -25 -43 15 -130 15 -145 0 -18 -18 -15 -52 6 -64 9 -6 42 -17 72 -24 69
-16 104 -34 124 -62 33 -47 10 -125 -47 -155 -43 -23 -168 -22 -220 1 -35 15
-38 20 -32 44 10 41 18 44 66 23 84 -39 182 -17 165 37 -7 20 -41 34 -138 56
-39 9 -86 52 -93 86 -9 39 20 97 59 121 39 24 150 26 202 4z m214 -133 c5
-136 6 -145 29 -163 36 -29 102 -26 135 7 25 26 26 29 26 159 0 72 2 134 5
136 2 3 20 3 40 1 l35 -4 0 -128 c0 -178 -19 -223 -107 -256 -55 -21 -133 -13
-179 18 -55 38 -68 76 -72 221 -2 70 -1 134 2 143 4 11 17 14 43 12 l38 -3 5
-143z m668 122 c54 -31 61 -105 15 -156 -13 -15 -12 -18 10 -33 60 -39 52
-135 -13 -167 -28 -14 -61 -18 -167 -18 l-133 0 0 193 c0 107 3 197 8 201 4 5
61 6 128 4 94 -4 127 -9 152 -24z m2237 -1883 c15 -69 109 -164 188 -190 20
-7 37 -16 37 -20 0 -4 -23 -15 -52 -26 -68 -24 -141 -97 -165 -165 -10 -27
-20 -50 -23 -50 -3 0 -13 23 -23 51 -24 67 -99 142 -167 166 -48 17 -65 33
-36 33 27 0 112 53 149 93 21 23 45 63 55 89 19 55 28 60 37 19z"/>
<path d="M5537 5965 c-25 -93 -50 -143 -103 -205 l-45 -53 2 -824 2 -823 23
-6 c13 -3 115 -4 226 -2 218 5 242 10 377 76 138 68 244 218 299 422 57 215
76 401 62 611 -10 146 -22 239 -39 294 -23 72 -101 289 -101 280 0 -5 -15 13
-34 40 -42 63 -127 143 -190 180 -92 54 -148 67 -311 72 l-150 5 -18 -67z
m223 -1114 c15 -28 13 -39 -10 -51 -40 -22 -80 26 -48 58 18 18 46 14 58 -7z
m274 -97 c10 -27 -11 -53 -43 -51 -18 1 -27 7 -24 15 3 7 0 18 -6 26 -15 18
-4 26 35 26 20 0 34 -6 38 -16z m-424 -37 c0 -2 -10 -12 -22 -23 l-23 -19 19
23 c18 21 26 27 26 19z m158 -92 c0 -29 0 -29 -8 -5 -4 14 -8 36 -8 50 -1 23
0 23 8 5 5 -11 8 -33 8 -50z m-258 -25 c-4 -14 -11 -35 -15 -47 l-7 -23 -29
21 c-16 11 -29 26 -29 34 0 23 29 44 59 42 24 -2 27 -5 21 -27z m302 -90 c-7
-11 -12 -28 -12 -37 -1 -17 -1 -17 -11 0 -5 9 -16 17 -24 17 -8 0 -19 9 -25
20 -8 15 -6 24 12 42 l23 23 25 -23 c20 -20 22 -26 12 -42z m-296 -42 c27 -83
27 -87 -1 -29 -23 49 -31 81 -21 81 3 0 12 -24 22 -52z m594 1 c9 -15 5 -21
-19 -34 -30 -15 -60 -21 -48 -8 4 3 2 12 -4 20 -9 9 -8 17 0 27 16 20 60 17
71 -5z m-292 -84 c-3 -3 -9 2 -12 12 -6 14 -5 15 5 6 7 -7 10 -15 7 -18z
m-215 -64 c14 -27 13 -30 -9 -40 -13 -6 -30 -8 -39 -5 -20 8 -29 42 -15 59 20
24 47 17 63 -14z m157 -66 c19 -7 28 -13 20 -13 -8 0 -31 6 -50 13 -19 7 -28
13 -20 13 8 0 31 -6 50 -13z m130 -24 c0 -39 -37 -50 -63 -20 -17 21 -17 22 0
35 10 7 28 14 41 14 18 0 22 -6 22 -29z"/>
<path d="M6731 4864 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6620 4830 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6711 4783 c7 -10 15 -20 16 -22 2 -2 3 5 3 17 0 14 -6 22 -16 22
-14 0 -15 -3 -3 -17z"/>
<path d="M6670 4629 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M6481 4374 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6465 4300 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 -8 0
-12 -4 -9 -10z"/>
<path d="M6215 4270 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M6160 4197 c-30 -9 -32 -11 -13 -15 13 -2 33 4 45 12 26 18 18 19
-32 3z"/>
<path d="M6168 4143 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6245 4139 c-12 -18 3 -22 20 -5 14 14 14 16 1 16 -8 0 -18 -5 -21
-11z"/>
<path d="M6205 4120 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/>
<path d="M4280 5211 l0 -91 49 0 c71 0 101 26 101 90 0 42 -4 52 -26 66 -14
10 -47 19 -75 22 l-49 5 0 -92z"/>
<path d="M3722 5157 c-6 -7 -8 -17 -4 -23 20 -30 82 -18 82 16 0 16 -6 20 -34
20 -18 0 -38 -6 -44 -13z"/>
<path d="M4532 5158 c-17 -17 -15 -26 7 -38 28 -14 71 4 71 30 0 16 -7 20 -33
20 -18 0 -38 -5 -45 -12z"/>
<path d="M4847 5163 c-12 -12 -7 -41 8 -47 23 -8 65 15 65 36 0 14 -8 18 -33
18 -19 0 -37 -3 -40 -7z"/>
<path d="M3357 2511 c-15 -38 -27 -71 -27 -75 0 -3 29 -6 65 -6 36 0 65 2 65
5 0 12 -63 145 -69 145 -4 0 -19 -31 -34 -69z"/>
<path d="M4590 2480 l0 -130 63 0 c108 0 157 41 157 131 0 83 -57 129 -160
129 l-60 0 0 -130z"/>
<path d="M5109 2512 c-15 -37 -25 -70 -22 -74 5 -10 123 -11 123 -1 0 12 -63
143 -69 143 -3 0 -18 -31 -32 -68z"/>
<path d="M5866 2515 c-14 -36 -26 -70 -26 -75 0 -6 27 -10 60 -10 33 0 60 3
60 7 0 16 -54 143 -61 143 -4 0 -19 -29 -33 -65z"/>
<path d="M7252 2563 l3 -48 58 -3 c66 -3 107 15 107 48 0 37 -27 50 -101 50
l-70 0 3 -47z"/>
<path d="M7257 2443 c-4 -3 -7 -29 -7 -56 l0 -49 80 4 c57 2 84 8 96 20 23 23
11 66 -22 78 -29 11 -137 13 -147 3z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
